import { FC } from 'react';
import { Link } from 'components/Link';
import { Control } from '@yleisradio/areena-types';
import styles from 'components/CategoryLinkControl/CategoryLinkControl.module.scss';

type Props = { control: Control; onClick(): void };

const CategoryLinkControl: FC<Props> = ({ control, onClick }) => {
  if (!control.destination) return null;
  return (
    <Link
      pointer={control.destination}
      className={styles.link}
      onClick={onClick}
    >
      {control.title}
    </Link>
  );
};

export { CategoryLinkControl };
